(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ], gameStatus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "idle", score = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        console.log(initialState);
        this.gameStatus = gameStatus;
        this.currentState = structuredClone(initialState);
        this.score = score;
        this.initialState = structuredClone(initialState);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.currentState[i];
                    var filteredRow = row.filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                        filteredRow[j] *= 2;
                        _this.score += filteredRow[j];
                        if (filteredRow[j] === 2048) _this.gameStatus = "win";
                        filteredRow[j + 1] = 0;
                        moved = true;
                    }
                    filteredRow = filteredRow.filter(function(num) {
                        return num !== 0;
                    });
                    while(filteredRow.length < 4)filteredRow.push(0);
                    if (!filteredRow.every(function(num, idx) {
                        return num === row[idx];
                    })) moved = true;
                    _this.currentState[i] = filteredRow;
                };
                var moved = false;
                for(var i = 0; i < this.currentState.length; i++)_loop(i);
                if (moved) {
                    this.addRandomTile();
                    this.checkGameOver();
                    return true;
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var row = _this.currentState[i];
                    var filteredRow = row.filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = filteredRow.length - 1; j > 0; j--)if (filteredRow[j] === filteredRow[j - 1]) {
                        filteredRow[j] *= 2;
                        _this.score += filteredRow[j];
                        if (filteredRow[j] === 2048) _this.gameStatus = "win";
                        filteredRow[j - 1] = 0;
                        moved = true;
                    }
                    filteredRow = filteredRow.filter(function(num) {
                        return num !== 0;
                    });
                    while(filteredRow.length < 4)filteredRow.unshift(0);
                    if (!filteredRow.every(function(num, idx) {
                        return num === row[idx];
                    })) moved = true;
                    _this.currentState[i] = filteredRow;
                };
                var moved = false;
                for(var i = 0; i < this.currentState.length; i++)_loop(i);
                if (moved) {
                    this.addRandomTile();
                    this.checkGameOver();
                    return true;
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.currentState = this.transpose(this.currentState);
                var moved = this.moveLeft();
                this.currentState = this.transpose(this.currentState);
                return moved;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.currentState = this.transpose(this.currentState);
                var moved = this.moveRight();
                this.currentState = this.transpose(this.currentState);
                return moved;
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.currentState;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.gameStatus;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.gameStatus = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.currentState = structuredClone(this.initialState);
                this.score = 0;
                this.gameStatus = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyTiles = [];
                for(var i = 0; i < this.currentState.length; i++){
                    for(var j = 0; j < this.currentState[i].length; j++)if (this.currentState[i][j] === 0) emptyTiles.push([
                        i,
                        j
                    ]);
                }
                var randomIndex = Math.floor(Math.random() * emptyTiles.length);
                var _emptyTiles_randomIndex = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyTiles[randomIndex], 2), row = _emptyTiles_randomIndex[0], col = _emptyTiles_randomIndex[1];
                this.currentState[row][col] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "transpose",
            value: function transpose(matrix) {
                var transposed = [];
                for(var col = 0; col < matrix[0].length; col++){
                    var newRow = [];
                    for(var row = 0; row < matrix.length; row++)newRow.push(matrix[row][col]);
                    transposed.push(newRow);
                }
                return transposed;
            }
        },
        {
            key: "checkGameOver",
            value: function checkGameOver() {
                for(var row = 0; row < this.currentState.length; row++)for(var col = 0; col < this.currentState[row].length; col++){
                    if (this.currentState[row][col] === 0) return false;
                }
                for(var row1 = 0; row1 < this.currentState.length - 1; row1++)for(var col1 = 0; col1 < this.currentState[row1].length - 1; col1++){
                    if (this.currentState[row1][col1] === this.currentState[row1][col1 + 1]) return false;
                    if (this.currentState[row1][col1] === this.currentState[row1 + 1][col1]) return false;
                }
                this.gameStatus = "lose";
                return true;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


"use strict";
var $197cd56b15c33885$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($3d28d7f1aac198f5$exports)))();
var $197cd56b15c33885$var$startButton = document.querySelector(".start.button");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$startX = 0;
var $197cd56b15c33885$var$startY = 0;
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$loseMessage.classList.add("hidden");
        $197cd56b15c33885$var$winMessage.classList.add("hidden");
    } else {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.replace("start", "restart");
        $197cd56b15c33885$var$startMessage.classList.add("hidden");
    }
    $197cd56b15c33885$var$updateGameField();
});
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
function $197cd56b15c33885$var$updateGameField() {
    var state = $197cd56b15c33885$var$game.getState();
    for(var i = 0; i < state.length; i++)for(var j = 0; j < state[i].length; j++){
        var cell = $197cd56b15c33885$var$gameField.rows[i].cells[j];
        var value = state[i][j];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add("field-cell--".concat(value));
    }
    $197cd56b15c33885$var$gameScore.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$winMessage.classList.remove("hidden");
    if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
}
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var moved = false;
    switch(e.key){
        case "ArrowLeft":
            moved = $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $197cd56b15c33885$var$game.moveDown();
            break;
    }
    if (moved) $197cd56b15c33885$var$updateGameField();
});
document.addEventListener("touchstart", function(e) {
    var touch = e.touches[0];
    $197cd56b15c33885$var$startX = touch.clientX;
    $197cd56b15c33885$var$startY = touch.clientY;
});
document.addEventListener("touchend", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var touch = e.changedTouches[0];
    var endX = touch.clientX;
    var endY = touch.clientY;
    var diffX = endX - $197cd56b15c33885$var$startX;
    var diffY = endY - $197cd56b15c33885$var$startY;
    var absX = Math.abs(diffX);
    var absY = Math.abs(diffY);
    // мінімальна довжина свайпу
    if (Math.max(absX, absY) < 30) return;
    var moved = false;
    if (absX > absY) // горизонтальний свайп
    moved = diffX > 0 ? $197cd56b15c33885$var$game.moveRight() : $197cd56b15c33885$var$game.moveLeft();
    else // вертикальний свайп
    moved = diffY > 0 ? $197cd56b15c33885$var$game.moveDown() : $197cd56b15c33885$var$game.moveUp();
    if (moved) $197cd56b15c33885$var$updateGameField();
});

})();
//# sourceMappingURL=index.3c059b03.js.map
